import { Card as AntCard, CardProps } from "antd";
import Text from "./text";

const Card = ({ title, className = "", ...props }: CardProps) => {
  return (
    <AntCard
      {...props}
      className={`rounded-card ${className}`}
      title={
        !!title &&
        (typeof title === "object" ? (
          <Text {...(title as any)} />
        ) : (
          <Text
            ellipsis
            level={4}
            weight={700}
            children={title}
            className="p-20-r"
            lineHeight="normal"
          />
        ))
      }
    />
  );
};

export default Card;
